// extracted by mini-css-extract-plugin
export default {"root":"oB6u9","align-items-center":"bs-iE","alignItemsCenter":"bs-iE"};